import React from "react";
import styled from "styled-components";
import { CTA } from "../../../components/CTA";
import { MediaImage } from "../../../components/Media";
const _HeaderBar = (props) => {
    const { logo, tagline, links, ...divProps } = props;
    let primaryCTA;
    let tertiaryCTA;
    if (links) {
        if (links[0]) {
            primaryCTA = links[0];
        }
        if (links[1]) {
            tertiaryCTA = links[1];
        }
    }
    return (React.createElement("div", { ...divProps },
        React.createElement("div", { className: "header-heading" },
            logo?.image ? (React.createElement("h1", { "data-testid": "header-logo", className: "logo" }, logo?.action?.type === "weblink" ? (React.createElement("a", { href: logo?.action.payload.url, title: logo.image?.accessibilityText, tabIndex: 0 },
                React.createElement(MediaImage, { media: logo?.image, optimized: true, fit: "height" }))) : (React.createElement(MediaImage, { media: logo?.image, optimized: true, fit: "height" })))) : null,
            tagline && (React.createElement("h2", { "data-testid": "header-tagline", className: "tagline" }, tagline))),
        React.createElement("div", { className: "links" },
            tertiaryCTA && (React.createElement(CTA, { variant: "tertiary", "data-testid": "header-tertiary-cta", className: "tertiary", ...tertiaryCTA })),
            primaryCTA && React.createElement(CTA, { "data-testid": "header-primary-cta", className: "primary", ...primaryCTA, tabIndex: 0 }))));
};
export const HeaderBar = styled(_HeaderBar) ``;
//# sourceMappingURL=HeaderBar.js.map